import { Link } from "react-router-dom";
import { Shield, HeartPulse, Car, Home as HomeIcon, Umbrella, Plane } from "lucide-react";

const PLANS = [
  { i: HeartPulse, t: "Health Insurance", d: "Cashless treatment at 10,000+ hospitals. Cover for family, seniors and critical illness." },
  { i: Shield, t: "Life Insurance", d: "Term, endowment and ULIP plans from India's leading insurers." },
  { i: Car, t: "Motor Insurance", d: "Comprehensive & third-party cover for car and two-wheeler with instant policy issuance." },
  { i: HomeIcon, t: "Home Insurance", d: "Protect your home & valuables against fire, theft and natural calamities." },
  { i: Umbrella, t: "General Insurance", d: "Shop, office and asset insurance tailored for MSMEs and traders." },
  { i: Plane, t: "Travel Insurance", d: "Domestic & international travel cover with 24/7 assistance worldwide." },
];

export default function Insurance() {
  return (
    <div data-testid="insurance-page" className="max-w-7xl mx-auto px-6 lg:px-10 py-16">
      <div className="sk-badge sk-badge-gold">Insurance</div>
      <h1 className="mt-4 font-display text-5xl text-white leading-tight">Protect what <span className="gold italic">matters most</span></h1>
      <p className="mt-4 text-white/60 max-w-xl">Curated insurance plans from India's top-rated insurers — advised, compared and serviced by SK Group.</p>
      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mt-14">
        {PLANS.map((p, i) => (
          <div key={i} className="sk-card-dark p-7" data-testid={`insurance-${p.t.toLowerCase().replace(/\s+/g,"-")}`}>
            <div className="w-12 h-12 rounded-xl bg-[#D4AF37]/15 border border-[#D4AF37]/30 flex items-center justify-center mb-5"><p.i className="text-[#D4AF37]" size={22}/></div>
            <div className="font-display text-2xl text-white">{p.t}</div>
            <p className="text-white/60 mt-2 text-sm">{p.d}</p>
            <Link to="/contact" className="mt-5 inline-block text-[#D4AF37] text-sm">Enquire now →</Link>
          </div>
        ))}
      </div>
    </div>
  );
}
